import { useTranslation } from "react-i18next";
import { Ban, CheckCircle2, Clock3, Coins, Gavel } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

// نفس بطاقات 3D Neu في الصفحة الرئيسية: ألوان كاملة زاهية ونغمات فريدة لكل بطاقة.
const CUR_TONES = ["orange", "fuchsia", "cyan", "lime"];

export const PenaltySummary = ({ rows, branches = [], ready = true }) => {
  const { t } = useTranslation();
  if (!ready) {
    return (
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6" data-testid="penalty-summary-loading">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-28 animate-pulse rounded-3xl bg-muted/50 shadow-neu-sm" />
        ))}
      </div>
    );
  }
  const approved = rows.filter((r) => r.status === "approved");
  const rejected = rows.filter((r) => r.status === "rejected" || r.status === "cancelled").length;
  const pending = rows.filter((r) => r.status === "pending").length;

  const currencies = [
    ...new Set([
      ...branches.map((b) => b.currency || b.primary_currency).filter(Boolean),
      ...rows.map((r) => r.currency).filter(Boolean),
    ]),
  ];
  if (!currencies.length) currencies.push("IQD");
  const sumFor = (cur) =>
    approved.filter((r) => r.currency === cur).reduce((a, r) => a + (Number(r.deduction_amount) || 0), 0);

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6" data-testid="penalty-summary">
      {currencies.map((cur, i) => (
        <StatCard key={cur} testId={`penalty-stat-deductions-${cur}`} tone={CUR_TONES[i % CUR_TONES.length]}
                  icon={Coins} label={`${t("penalty.summary.deductions")} · ${cur}`}
                  value={sumFor(cur).toLocaleString()} />
      ))}
      <StatCard testId="penalty-stat-rejectedCancelled" tone="teal" icon={Ban}
                label={t("penalty.summary.rejectedCancelled")} value={rejected} />
      <StatCard testId="penalty-stat-approved" tone="rose" icon={CheckCircle2}
                label={t("penalty.summary.approved")} value={approved.length} />
      <StatCard testId="penalty-stat-pending" tone="amber" icon={Clock3}
                label={t("penalty.summary.pending")} value={pending} />
      <StatCard testId="penalty-stat-total" tone="indigo" icon={Gavel}
                label={t("penalty.summary.total")} value={rows.length} />
    </div>
  );
};
